import React, { useEffect } from "react";
import { useState } from "react";

import { Trans, withTranslation } from "react-i18next";
import "./privacypolicyPage.styled";
import PrivacypolicyPageDisplay from "./privacypolicyPage.styled";

function privacypolicyPage() {
  const [direction, setDirection] = useState("ltr");
  const [textAlign, setTextAlign] = useState("left");

  const brand = window.location.hostname.includes("ao.playit")
    ? "playit"
    : "gamezworld";
  const p = (key) => `${brand}.${key}`;

  useEffect(() => {
    const language = localStorage.getItem("i18nextLng");
    if (language === "ar") {
      setDirection("rtl");
      setTextAlign("right");
    } else {
      setDirection("ltr");
      setTextAlign("left");
    }
  }, []);

  return (
    <PrivacypolicyPageDisplay>
      <div style={{ direction, textAlign }}>
        <h1>
          <Trans i18nKey={p("Privacy")} />
        </h1>

        <h2>
          <Trans i18nKey={p("Introduction")} />
        </h2>
        <p>
          <Trans i18nKey={p("Welcometo")} />
        </p>

        <h2>
          <Trans i18nKey={p("Information")} />
        </h2>
        <p>
          <Trans i18nKey={p("Wemay")} />
        </p>
        <ul>
          <li>
            <strong>
              <Trans i18nKey={p("PersonalIdentification")} />
            </strong>{" "}
            <Trans i18nKey={p("Name")} />
          </li>
          <li>
            <strong>
              <Trans i18nKey={p("TechnicalData")} />
            </strong>{" "}
            <Trans i18nKey={p("IPaddress")} />
          </li>
          <li>
            <strong>
              <Trans i18nKey={p("Usage")} />
            </strong>{" "}
            <Trans i18nKey={p("Informationabout")} />
          </li>
          <li>
            <strong>
              <Trans i18nKey={p("Cookies")} />
            </strong>{" "}
            <Trans i18nKey={p("Informationcollected")} />
          </li>
        </ul>

        <h2>
          <Trans i18nKey={p("HowWe")} />
        </h2>
        <p>
          <Trans i18nKey={p("Weuse")} />
        </p>
        <ul>
          <li>
            <Trans i18nKey={p("Toprovide")} />
          </li>
          <li>
            <Trans i18nKey={p("Toimprove")} />
          </li>
          <li>
            <Trans i18nKey={p("Tounderstand")} />
          </li>
          <li>
            <Trans i18nKey={p("Todevelop")} />
          </li>
          <li>
            <Trans i18nKey={p("Tocommunicate")} />
          </li>
          <li>
            <Trans i18nKey={p("Toprocess")} />
          </li>
          <li>
            <Trans i18nKey={p("Tosend")} />
          </li>
          <li>
            <Trans i18nKey={p("Tofind")} />
          </li>
        </ul>

        <h2>
          <Trans i18nKey={p("Sharing")} />
        </h2>
        <p>
          <Trans i18nKey={p("Wedonot")} />
        </p>
        <ul>
          <li>
            <strong>
              <Trans i18nKey={p("ServiceProviders")} />
            </strong>{" "}
            <Trans i18nKey={p("Wemayshare")} />
          </li>
          <li>
            <strong>
              <Trans i18nKey={p("BusinessTransfers")} />
            </strong>{" "}
            <Trans i18nKey={p("Wemayshareortransfer")} />
          </li>
          <li>
            <strong>
              <Trans i18nKey={p("LegalRequirements")} />
            </strong>{" "}
            <Trans i18nKey={p("Wemaydisclose")} />
          </li>
        </ul>

        <h2>
          <Trans i18nKey={p("Security")} />
        </h2>
        <p>
          <Trans i18nKey={p("Weuseadministrative")} />
        </p>

        <h2>
          <Trans i18nKey={p("YourData")} />
        </h2>
        <p>
          <Trans i18nKey={p("Dependingon")} />
        </p>

        <h2>
          <Trans i18nKey={p("Changes")} />
        </h2>
        <p>
          <Trans i18nKey={p("Wemayupdate")} />
        </p>

        <h3>
          <Trans i18nKey={p(brand)} />{" "}
          <a href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes">
            <Trans>Google API Services User Data Policy</Trans>
          </a>
          , <Trans i18nKey={p("including")} />
        </h3>

        <h2>
          <Trans i18nKey={p("Contact Us")} />
        </h2>
        <p>
          <Trans i18nKey={p("Ifyou")} />
        </p>
        <ul>
          <li>
            <Trans i18nKey={p("Email")} />
          </li>
        </ul>

        <p>
          <Trans i18nKey={p("Byusing")} />
        </p>
      </div>
    </PrivacypolicyPageDisplay>
  );
}

export default withTranslation()(privacypolicyPage);
